
    import {groupInstrumentByType, groupInstrumentByCity,groupInstrumentCountByType, groupInstrumentCountByCity} from "../../js/instrumentType/instrumentType";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import echarts from "echarts";
    import baseUrl, {imageUrl, uploadPage} from "@/constants";
    import {instrumentAll} from "@/js/referenceMaterial/referenceMaterial";
    @Component({
        name: "Approval_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = '';
        mode = '0' //0 按器具分类统计  1 生产企业地区分布情况统计
        resultList = [] as any;
        tableList = [] as any;
        pageIndex = 0;
        pageSize = 10;
        totalCount = 0;
        modal = {
            visible: false,
        }
        listTotal = 0;
        showForm = false;
        instrumentTypes = [
          {name: '备案申报手续', id: '1'},
          {name: '政务云对接申报材料', id: '2'},
          {name: '信息化项目备案', id: '3'},
        ];
        propParams = {
            city_name: "",
            instr_type: "",
            instr_name: "",
            org_name: "",
          start: '',
          end: ''
        }
        myChart = null as any;
        fullScreen = false;

        // 增删改
        editId = '';
        editDialog = false;
        addform = {
          name: "",  //项目名称
          file1: "",    //项目类型
          file2: "",    //项目类型
          file3: "",    //项目类型
          times: "",    //时间
          user: "",    //负责人
        } as any
      baseUrl = baseUrl;
      imageUrl = imageUrl;
      headers = {Authorization:""}
      fileListCheck1 = [] as any;
      fileListCheck2 = [] as any;
      fileListCheck3 = [] as any;

        mounted() {
          this.jumpPage(1);
        }

        indexMethod(index: any) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        }
        doLayout(el: any){
           const e = this.$refs[el] as any;
            if(e){
                e.doLayout() // 解决表格错位
            }
        }
        pageSizeChange(val: number) {
            this.pageSize = val;
            this.jumpPage(this.pageIndex);
        }
        refresh(){
            this.jumpPage(1);
        }
        reset(){
            this.propParams.instr_name = '';
            this.propParams.start = '';
            this.propParams.end = '';
            this.propParams.org_name = '';
            this.refresh();
        }
        jumpPage(val: any){
            let resultList = JSON.parse(JSON.stringify(this.resultList));
            const {instr_name, instr_type, city_name, org_name} = this.propParams;
            if(instr_name != ''){
                resultList = resultList.filter((r: any) => r.instr_name.indexOf(instr_name) > -1);
            }
            if(instr_type != ''){
                resultList = resultList.filter((r: any) => r.instr_type == instr_type);
            }
            if(city_name != ''){
                resultList = resultList.filter((r: any) => r.city_name.indexOf(city_name) > -1);
            }
            if(org_name != ''){
                resultList = resultList.filter((r: any) => r.org_name.indexOf(org_name) > -1);
            }
            const tableList = resultList;
            this.totalCount = resultList.length;
            this.pageIndex = val;
            const pageIndex = val;
            const pageSize = this.pageSize;
            const totalCount = tableList.length;
            const start = (pageIndex - 1) * pageSize;
            const end = pageIndex * pageSize > totalCount ? totalCount : pageIndex * pageSize;
          // this.tableList = tableList.slice(start, end);
          this.tableList = [
            {name: '公司官网备案申报', times: '2023-11-16', status: '网站备案申报', user: '张三', note: ''}
          ]
          this.totalCount = 1;
        }
        loadGroupInstrumentCountByCity(){
            let resultList = [] as any;
            for(let m in groupInstrumentByCity){
                resultList =  resultList.concat(groupInstrumentByCity[m]);
            }
            this.resultList = resultList;
            const tableData = groupInstrumentCountByCity;
            const xAxisData = tableData.map((t: any) => t.name);
            const seriesData = tableData.map((t: any) => t.value);
            this.jumpPage(1);
            this.loadEchart(xAxisData, seriesData);
        }
        loadGroupInstrumentCountByType(){
            let resultList = [] as any;
            for(let m in groupInstrumentByType){
                resultList =  resultList.concat(groupInstrumentByType[m]);
            }
            this.resultList = resultList;
            const tableData = groupInstrumentCountByType;
            const xAxisData = tableData.map((t: any) => t.name);
            const seriesData = tableData.map((t: any) => t.value);
            this.jumpPage(1);
            this.loadEchart(xAxisData, seriesData);
        }
        loadEchart(xAxisData: any, seriesData: any){
            if(this.myChart){
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart1);
            this.myChart.setOption({
                title: {
                    text: this.title
                },
                tooltip: {},
                xAxis: {
                    data: xAxisData
                },
                yAxis: {},
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 50
                    },
                    {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 50
                    }
                ],
                series: [
                    {
                        name: this.mode == '0' ? '分类' : '地区',
                        type: 'bar',
                        data: seriesData,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                    offset: 0,
                                    color: "#1268f3" // 0% 处的颜色
                                }, {
                                    offset: 0.6,
                                    color: "#08a4fa" // 60% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#01ccfe" // 100% 处的颜色
                                }], false)
                            },
                        },
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'red',
                                fontSize: 16
                            }
                        }
                    }
                ]
            });
        }

        // 增删改
      add() {
          this.addform = {
            name: "",  //项目名称
            status: "",    //项目类型
            times: "",    //时间
            user: "",    //负责人
          }
        this.fileListCheck1 = [];
        this.fileListCheck2 = [];
        this.fileListCheck3 = [];
          this.editDialog = true;
          this.editId = '';
      }
      saveBtn() {
          if (this.editId) {
            this.$set(this.tableList,this.editId,this.addform);
          } else {
            const form = Object.assign({}, this.addform, {id: this.tableList.length});
            this.tableList.push(form);
          }
          this.editDialog = false;
          this.totalCount = this.tableList.length;
      }
      del(index: number) {
        this.$confirm('确定要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableList.splice(index, 1);
          this.totalCount = this.tableList.length;
        })
      }
      edit(index: number) {
        this.editId = String(index);
        this.addform = JSON.parse(JSON.stringify(this.tableList[index]));
        if (this.addform.file1) {
          this.fileListCheck1 = [{url: this.addform.file1, name: '备案申报手续'}];
        }
        if (this.addform.file2) {
          this.fileListCheck2 = [{url: this.addform.file2, name: '政务云对接申报材料'}];
        }
        if (this.addform.file3) {
          this.fileListCheck3 = [{url: this.addform.file3, name: '信息化项目备案'}];
        }
        this.editDialog = true;
      }

      //上传检定结果复印件
      //上传监控
      handleAvatarSuccessCheck1(res: any, file: any) {
        if (res.result === 0) {
          const rData = res.data;
          this.addform.file1 = rData;
        }
      }
      handleRemoveCheck1(file: any, fileList: any) {
        this.addform.file1 = '';
      }
      handleAvatarSuccessCheck2(res: any, file: any) {
        if (res.result === 0) {
          const rData = res.data;
          this.addform.file2 = rData;
        }
      }
      handleRemoveCheck2(file: any, fileList: any) {
        this.addform.file2 = '';
      }
      handleAvatarSuccessCheck3(res: any, file: any) {
        if (res.result === 0) {
          const rData = res.data;
          this.addform.file3 = rData;
        }
      }
      handleRemoveCheck3(file: any, fileList: any) {
        this.addform.file3 = '';
      }
      handlePictureCardPreviewCheck(file: any) {
        window.open(baseUrl + "/file/download?file=" + file.url + "&name=" + file.name, '_blank');
      }
      //上传监控
      beforeAvatarUploadCheck(file: any) {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          this.$message.error('上传图片只能是PDF格式!');
        }
        return (isPDF);
      }
      openFile(row: any, type: number) {
          this.handlePictureCardPreviewCheck({url: row['file'+type], name: this.instrumentTypes[type].name})
      }
    }
